module.exports = __webpack_public_path__ + "static/media/folder_rename.9ef45a1d.ico";